import { ApiError } from '../services/whatsappApi';

// Linking a conversation to a patient file, or creating one from the inbox (flow 9).

/** The search starts at this many characters: shorter terms match half the clinic. */
export const MIN_QUERY_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 300;

export const SEARCH_ERROR_TEXT = 'No se pudo buscar. Intenta de nuevo.';
export const LINK_ERROR_TEXT = 'No se pudo vincular. Intenta de nuevo.';
export const LINK_GONE_TEXT = 'Esa ficha ya no está disponible. Busca de nuevo.';
export const CREATE_ERROR_TEXT = 'No se pudo crear el paciente. Revisa los datos e intenta de nuevo.';

/** What the search box shows for the term typed so far. */
export const searchTerm = (raw: string): { query: string; ready: boolean } => {
  const query = raw.trim();
  return { query, ready: query.length >= MIN_QUERY_LENGTH };
};

/** The number in the format the patient form stores: 8 digits for Guatemala, otherwise the digits as they came. */
export const localPhone = (waId: string): string => {
  const digits = waId.replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('502') ? digits.slice(3) : digits;
};

/** The id `createPatient` returns (number or text) as a positive integer, or null when it is not one. */
export const createdPatientId = (id: string | number): number | null => {
  const n = typeof id === 'number' ? id : Number(String(id).trim());
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const canCreate = (firstName: string, lastName: string): boolean =>
  firstName.trim() !== '' && lastName.trim() !== '';

/** `YYYY-MM-DD…` as `DD/MM/YYYY` without going through a timezone; "—" when there is no visit. */
export const visitLabel = (iso: string | null): string => {
  const m = iso ? /^(\d{4})-(\d{2})-(\d{2})/.exec(iso) : null;
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
};

export type LinkFailure = { kind: 'gone'; text: string } | { kind: 'error'; text: string };

/** What a failed PUT /patient means for the dialog: the file vanished (404) or anything else. */
export const linkFailure = (err: unknown): LinkFailure =>
  err instanceof ApiError && err.status === 404
    ? { kind: 'gone', text: LINK_GONE_TEXT }
    : { kind: 'error', text: LINK_ERROR_TEXT };
